import { Spacer } from '@zillow/constellation';
import { Box, Image, Page, Text } from '@zillow/constellation-10';

import PremiumProductOptionsSimple, { COMPONENT_SECTION_CONTEXT } from '../PremiumProductOptionsSimple';

import PremiumBadge from '../../images/premium-badge.png';

const PremiumUpsell = () => {
  return (
    <Box
      data-testid="PremiumUpsell"
      css={{
        backgroundColor: 'bg.express.trust.soft',
        display: 'flex',
        justifyContent: 'center',
        position: 'relative',
        left: '50%',
        width: '100vw',
        transform: 'translateX(-50%)',
      }}
    >
      <Page.Content css={{ padding: '400', width: '100%', maxWidth: '375px', boxSizing: 'border-box' }}>
        <Spacer paddingTop={5} paddingBottom={10}>
          <Box css={{ textAlign: 'center' }}>
            <Image src={PremiumBadge} alt="premium badge" css={{ width: '107px' }} />
          </Box>

          <Spacer marginBottom="xs" />

          <Text textStyle="heading-xs" asChild css={{ marginBottom: '200' }}>
            <p>Get the most out of your listing with premium</p>
          </Text>
          <Text asChild>
            <p>
              Get up to 3x more views on your listing and gain access to deeper insights and analytics to help you price
              your rental and optimize your listing.
            </p>
          </Text>

          <PremiumProductOptionsSimple componentSectionContext={COMPONENT_SECTION_CONTEXT.BOTTOM} />
        </Spacer>
      </Page.Content>
    </Box>
  );
};

export default PremiumUpsell;
